const indexItems = [
  { label: '明星八卦', count: '328篇', icon: 'ri-star-line' },
  { label: '网红爆料', count: '256篇', icon: 'ri-live-line' },
  { label: '综艺内幕', count: '189篇', icon: 'ri-tv-line' },
  { label: '社会热点', count: '412篇', icon: 'ri-fire-line' },
  { label: '品牌翻车', count: '145篇', icon: 'ri-shopping-bag-line' },
  { label: '选秀造假', count: '98篇', icon: 'ri-mic-line' },
  { label: '平台纠纷', count: '173篇', icon: 'ri-computer-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10 text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            📑 主题索引
          </h2>
          <p className="text-sm text-foreground-600">
            按主题分类浏览，快速找到您感兴趣的黑料内容
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 text-center hover:border-primary-200/50 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer no-underline group"
            >
              <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center mx-auto mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-accent-600 text-xl`}></i>
              </div>
              <div className="font-heading text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">
                {item.label}
              </div>
              <div className="text-xs text-foreground-500">
                {item.count}
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}